import { IHttpApi } from '@cian/http-api';
import { FetchResponse } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { ResponseError } from 'shared/errors/ResponseError';
import {
  fetchGetOffersForSpecificNewbuildingSearchSlider,
  TGetOffersForSpecificNewbuildingSearchSliderRequest,
  TGetOffersForSpecificNewbuildingSearchSliderResponse,
} from 'shared/repositories/newbuilding-brand-promotion/v1/get-offers-for-specific-newbuilding-search-slider';

interface IGetOffersForSpecificNewbuildingSearchSliderParams {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: TGetOffersForSpecificNewbuildingSearchSliderRequest;
}

export const resolveGetOffersForSpecificNewbuildingSearchSlider = async ({
  httpApi,
  logger,
  parameters,
}: IGetOffersForSpecificNewbuildingSearchSliderParams) => {
  try {
    const responseData: FetchResponse<TGetOffersForSpecificNewbuildingSearchSliderResponse> =
      await fetchGetOffersForSpecificNewbuildingSearchSlider({
        httpApi,
        parameters,
      });

    if (responseData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'resolveGetOffersForSpecificNewbuildingSearchSlider',
        message: responseData.response.message || 'Неизвестная ошибка',
      });
    }

    return responseData.response.offers;
  } catch (error) {
    logger.error(error, {
      domain: 'resolveGetOffersForSpecificNewbuildingSearchSlider',
    });

    return null;
  }
};
